import React from 'react';
export function IdentitySection() {
  return <section className="py-16 md:py-24 px-4 bg-cream relative overflow-hidden" data-id="element-148" data-mp="2y2560xosjlft">
      {/* Decorative background */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-forest/5 rounded-l-full blur-3xl -z-10 transform translate-x-1/4" data-id="element-149" data-mp="dmwq53ynpvoe"></div>

      <div className="max-w-3xl mx-auto" data-id="element-150" data-mp="mm9zlwms6k94">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-forest mb-12 text-center" data-id="element-151" data-mp="ml8fz3rp8pfs">
          Imagina Tu Próxima Semana
        </h2>

        <div className="prose prose-lg md:prose-xl prose-p:text-dark/80 mx-auto space-y-6" data-id="element-152" data-mp="3q27bqb4i62a3">
          <p data-id="element-153" data-mp="3v1tqiozzbql0">Es lunes por la mañana.</p>
          <p data-id="element-154" data-mp="3v0s3dm5ovdmx">Suena el despertador.</p>
          <p data-id="element-155" data-mp="3uzqqdc544h2k">Te despiertas.</p>
          <p data-id="element-156" data-mp="3nfmes2ytrv2">
            Y antes de pensar en nada, antes de revisar el teléfono, antes del
            café...
          </p>

          <p className="text-xl md:text-2xl font-bold text-forest my-8" data-id="element-157" data-mp="32c4nk63plggr">
            Notas algo diferente.
          </p>

          <p data-id="element-158" data-mp="37a68kwkp3puv">
            Tu vientre está plano. No perfectamente plano, sino diferente al de
            ayer. Más ligero. Sin esa presión habitual.
          </p>
          <p data-id="element-159" data-mp="12kl0in6nqo3a">
            Te incorporas sin ese cansancio denso que llevabas meses
            arrastrando.
          </p>
          <p data-id="element-160" data-mp="xr8nzbf967qw">Vas al espejo.</p>
          <p className="font-bold text-dark" data-id="element-161" data-mp="xqguc657uk39">
            Y esta vez no apartas la mirada.
          </p>

          <hr className="border-forest/20 my-10" data-id="element-162" data-mp="num4or2kroqz" />

          <p data-id="element-163" data-mp="nvf2h2jk33wz">
            El miércoles llegas a casa a las 8 PM con el mismo cansancio de
            siempre. Pero esta vez, en lugar de ese agobio de "¿qué como que no
            me haga daño?", abres tu protocolo, eliges una receta, y en 15
            minutos tienes una cena deliciosa en la mesa.
          </p>
          <p data-id="element-164" data-mp="9wp6xrcdxcaq">Te vas a la cama.</p>
          <p data-id="element-165" data-mp="297yrgmsaklgt">Duermes profundamente.</p>

          <hr className="border-forest/20 my-10" data-id="element-166" data-mp="296x8zx8y4wp2" />

          <p data-id="element-167" data-mp="248vtfmaqbfic">
            El viernes, alguien en tu trabajo te pregunta si hiciste algo
            diferente.
          </p>
          <p data-id="element-168" data-mp="2ncz2ie6saw44">Tienes más brillo. Más energía. Algo cambió.</p>
        </div>

        <div className="mt-16 bg-white p-8 rounded-2xl shadow-warm border border-gold/20 text-center" data-id="element-169" data-mp="2s47ar6wdobfp">
          <p className="text-xl md:text-2xl font-serif font-bold text-forest mb-4" data-id="element-170" data-mp="2ecsn2mrizm2b">
            Esa mujer no está lejos. Está a 7 días de distancia.
          </p>
          <p className="text-lg font-bold text-urgency" data-id="element-171" data-mp="2jc5cnf9s778l">
            Y a un clic de distancia ahora mismo.
          </p>
        </div>
      </div>
    </section>;
}